<form [formGroup]="form" class="row">
     <!-- Caso autorizacionTransaccion  -->
     <div class="col-12" >
        <mat-form-field appearance="outline" class="col-6">
            <mat-label>Tipo Validacion</mat-label>
            <mat-select  formControlName="tipo_validacion"  >
              <mat-option  *ngFor="let tipo of tipo_validaciones"  [value]="tipo">
                {{tipo}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        <mat-form-field  appearance="outline" class="col-6">
          <mat-label>C.I./R.I.F de la persona</mat-label>
          <input ciRif formControlName="ci_persona"  matInput>
        </mat-form-field>
        <mat-form-field  appearance="outline" class="col-6">
          <mat-label>Nombres y Apellidos Persona</mat-label>
          <input formControlName="nombre_apellido"  matInput>
        </mat-form-field>
      </div>
</form>
